<template>
    <div class="document-client">
        <title-screen title="19"></title-screen>
        <AnkenInfo :id="ankenId" @ankenInfoLoad="ankenInfoLoad" @scrollFileData="scrollToPDF"/>
        <el-row style="padding-bottom: 1em" class="create-time">
            <el-col align="right" v-if="url != null">更新日:   {{ publishedAt }}</el-col>
        </el-row>
        <div class="panel file-content" v-if="url == null"><h1>相続申告スケジュールはまだ作成されていません。</h1></div>
        <div v-else-if="isMobile || isIE">
            <pdfjs :src="url" @loaded="pdfLoad"></pdfjs>
        </div>
        <iframe class="iframe-file" v-else :src="url" type="application/pdf" title="PDF file" width="100%" height="1200px" @load="pdfLoad"></iframe >
    </div>
</template>

<script>
import AnkenInfo from '../38_anken/AnkenInfo.vue'
import DocumentApi from '@/api/document/document.js'
import TitleScreen from '@/components/common/TitleScreen'
// import { scroller } from 'vue-scrollto/src/scrollTo'
import { isMobile } from 'mobile-device-detect'
import Pdfjs from '../../../../components/pdfjs/Pdfjs'
import { isIE } from '@/common/useragent'
let moment = require('moment')

export default {
  name: 'document-client',
  data () {
    return {
      publishedAt: null,
      filePath: null,
      url: null,
      ankenId: 0,
      isAnkenInfoLoaded: false,
      isPagesLoaded: false,
      scr: null,
      numPages: undefined,
      isMobile: isMobile
    }
  },
  components: {
      Pdfjs,
    TitleScreen,
    AnkenInfo
  },
  mounted () {
    this.ankenId = parseInt(this.$route.params.id)
    this.getUrlPublishSchedule()
  },
  methods: {
    async getUrlPublishSchedule () {
      if (this.ankenId) {
        await DocumentApi.updateNoticeOff(this.ankenId)

        await DocumentApi.getPublishFile(this.ankenId).then((response) => {
          if (response.data.status === 200) {
            this.filePath = response.data.data.filePath
            this.publishedAt = moment.parseZone(response.data.data.publishedAt).format('YYYY年MM月DD日')

            const payload = {
              filePath: this.filePath
            }
            DocumentApi.getSignedUrl(payload).then((responseDocument) => {
              if (responseDocument.data.code === 200) {
                this.url = responseDocument.data.signedUrl
              }
            })
          }
          // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          throw err
        })
      }
    },
    ankenInfoLoad (val) {
      this.isAnkenInfoLoaded = val
    },
    scrollToPDF () {
        // IEの場合、iframeのonloadが正常に呼び出されないので、PDFのロードを待たずにスクロールする
        if (this.isAnkenInfoLoaded && (this.isPagesLoaded || isIE())) {
            this.$nextTick(() => {
              const ankenViews = document.getElementsByClassName('anken-info')
              if (ankenViews.length > 0) {
                  const ankenView = ankenViews[0]
                  if (ankenView) {
                      var navHeight = 0
                      if (window.innerWidth > 600 && window.innerHeight > 400) {
                          const navViews = document.getElementsByClassName('gnav nav-height')
                          if (navViews.length > 0) {
                              const navView = navViews[0]
                              if (navView) {
                                  navHeight = navView.offsetHeight
                                  if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                              }
                          }
                      }
                      const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
                      window.scroll(0, scrollTop)
                  }
              }
          })
        }
    },
    pdfLoad () {
        this.isPagesLoaded = true
    }
  },
  computed: {
      isIE () {
          return isIE()
      }
  },
  watch: {
    isAnkenInfoLoaded: function () {
        this.scrollToPDF()
    },
    isPagesLoaded: function () {
        this.scrollToPDF()
    }
  }
}</script>

<style>
    @import './document.css';
</style>
